"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MarkerFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_MarkerFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.753.344a1.897 1.897 0 0 1 1.177 0c.248.08.455.222.658.395.194.165.414.387.68.653l.595.598c.265.266.486.487.65.682.173.204.314.411.394.66.124.382.124.794 0 1.177a1.95 1.95 0 0 1-.393.66c-.165.195-.386.416-.65.682l-7.425 7.452-4.446-4.461 7.422-7.45c.266-.266.486-.488.68-.653.203-.173.41-.315.658-.395ZM2.293 9.556a2.378 2.378 0 0 0-.418.706 4.108 4.108 0 0 0-.161.647l-.428 2.149-1.14 1.144a.5.5 0 0 0 .096.781l.557.335.065.04c.291.176.555.336.845.377.253.037.51.005.747-.092.27-.11.488-.33.729-.572l.053-.054.002-.002 2.14-.43c.271-.054.463-.092.645-.161a2.365 2.365 0 0 0 .702-.42L2.293 9.557Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_MarkerFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = MarkerFill;
exports["default"] = _default;